import { Controller } from "stimulus"

export default class extends Controller {
  static values = { url: String }

  update(elem) {
    const src = `${this.urlValue}?days=${elem.target.value}`
    elem.target.closest('#analytics').setAttribute('src', src)
  }
}
